import ObjectUtils from "./ObjectUtils";

/**
 * Calculate page/question visibility depanding on page definition and triggers states(answers on question with
 * triggers).
 */
export function isVisible(target, triggerState) {
  let visible = false;
  if (target) {
    let targetName = target.name;
    let targetKey = target.key;
    const isTriggeredByKey =
      targetKey && ObjectUtils.findByObjectProp(triggerState, "targetKey", targetKey).targetKey !== undefined;
    const isTriggeredByName = ObjectUtils.findByObjectProp(triggerState, "targetName", targetName).targetName !== undefined;
    if (
      target.visible !== false ||
      isTriggeredByKey ||
      isTriggeredByName
    ) {
      visible = true;
    }
  }
  return visible;
}

/**
 * Return new collection with only visible targets(pages/questions).
 * @See #isVisible
 */
export function visibleCollection(collection, triggerState) {
  return collection
    ? collection.filter((page) => {
        return isVisible(page, triggerState);
      })
    : [];
}
